import React, { useContext } from 'react';
import useTags from '@ubeya/shared/hooks/account/useTags';
import styled, { css } from 'styled-components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { Tooltip } from '@ubeya/shared-web/components';

export const TagContainer = styled.div.attrs(() => ({ className: 'tags-badges-container' }))`
  padding: 4px 8px;
  font-size: 12rem;
  border-radius: 4px;
  display: flex;
  border: 1px solid ${({ theme }) => theme.colors.grey2};
  background: ${({ theme }) => theme.colors.white};
  gap: 4px;
  flex: ${({ $isFixedWidth }) => ($isFixedWidth ? '0 0 auto' : '1 1 0')};
  min-width: 0;
  max-width: fit-content;
  height: 24px;
  align-items: center;
`;

export const TagDot = styled.div`
  width: 9px;
  height: 9px;
  border-radius: 100%;
  position: relative;

  ${({ $color }) => css`
    background: ${$color};
    border: 1px solid var(--ui-border-command-bar, rgba(82, 82, 111, 0.44));
  `};
`;

const TagDots = styled.div`
  display: flex;
  align-items: center;
  ${TagDot}+${TagDot} {
    margin-left: -4px;
  }
`;
const TagLine = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const TagName = styled.div`
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const TagsBadges = ({ tags = [], isCompact = false, getLabel, tooltipHeader, tooltipFooter }) => {
  const { t } = useContext(ConfigContext);
  const { mappedTags } = useTags();

  if (!tags.length) {
    return null;
  }

  return (
    <Tooltip
      body={
        <>
          {tooltipHeader}
          {tags.map((tag) => {
            return (
              <TagLine key={tag}>
                <TagDot $color={mappedTags[tag]?.color} />
                {mappedTags[tag]?.label}
              </TagLine>
            );
          })}
          {tooltipFooter}
        </>
      }>
      <TagContainer $isFixedWidth={tags.length > 1}>
        <TagDots>
          {tags.slice(0, 3).map((tag) => {
            return <TagDot key={tag} $color={mappedTags[tag]?.color} />;
          })}
        </TagDots>
        {!isCompact && (
          <TagName data-testid="tag-name-badge">
            {getLabel
              ? getLabel(tags)
              : tags.length === 1
              ? mappedTags[tags[0]]?.label || ''
              : t('projectTags', { value: tags.length })}
          </TagName>
        )}
      </TagContainer>
    </Tooltip>
  );
};

export default TagsBadges;
